import {Component, OnInit} from '@angular/core';
import {EventsService} from "../../../events.service";
import {GlobalService} from "../../../../global.service";

@Component({
  selector: 'app-cfc-stats',
  templateUrl: './cfc-stats.component.html',
  styleUrls: ['./cfc-stats.component.css']
})
export class CfcStatsComponent implements OnInit {
  
  constructor(public eventService: EventsService, public globalService: GlobalService) {
  }
  
  ngOnInit() {
  }
  
}
